import { registerPropertyManagerSection } from '@/core';
import ReferenceAxisPropertySection from '@/components/editor/property-manager/reference/ReferenceAxisPropertySection.vue';

registerPropertyManagerSection({
  id: 'reference-axis',
  title: '基准轴',
  order: 35,
  component: ReferenceAxisPropertySection,
  actions: {
    confirm: true,
    cancel: true,
  },
  isApplicable: (context) => context.activeCommand === 'geometry-reference-axis' || Boolean(context.referenceAxisActive),
  onConfirm: (context) => {
    context.submitReferenceAxis?.();
  },
  onCancel: (context) => {
    context.cancelReferenceAxis?.();
  },
});
